var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon / Indicator / Local green") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M30,36.9083933 C30,36.9005449 36,28.3137085 36,25 C36,21.6862915 33.3137085,19 30,19 C26.6862915,19 24,21.6862915 24,25 C24,28.3137085 30,36.9162417 30,36.9083933 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Awards-&-Illustrations",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Indicator-/-Local-green"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 60,
    height: 60
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-5",
    stroke: "#BF2784",
    points: "21.25 39.5 38.75 39.5 34.5659373 34 25.4800754 34"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Oval-4"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#BF2785",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFFFFF",
    strokeWidth: 0.75,
    d: "M30.375,36.9083933 L29.7721848,37.2062611 L29.7151559,37.1523243 C29.7107219,37.1470976 29.7107219,37.1470976 29.7052709,37.1403012 C29.6997123,37.1331156 29.6997123,37.1331156 29.6973468,37.1299118 C29.6936536,37.124869 29.6936536,37.124869 29.6907274,37.1207885 C29.6844212,37.1119369 29.6844212,37.1119369 29.6760153,37.100002 C29.655375,37.0705539 29.655375,37.0705539 29.6244399,37.026018 C29.5718899,36.9502223 29.5061971,36.8545737 29.4322211,36.7459305 C29.2291109,36.4476376 28.9976707,36.1017163 28.7489801,35.7227514 C28.0447493,34.6496157 27.3368443,33.5181351 26.6763256,32.3891475 C24.7655301,29.1231321 23.625,26.5432933 23.625,25 C23.625,21.4791847 26.4791847,18.625 30,18.625 C33.5208153,18.625 36.375,21.4791847 36.375,25 C36.375,26.2236866 35.6558183,28.0978467 34.3846615,30.4886443 C34.0608421,31.0976852 33.7055058,31.7311177 33.3236112,32.3833692 C32.6646042,33.5089109 31.9597162,34.635262 31.2511008,35.7160059 C31.0053927,36.0907475 30.7779569,36.4313777 30.5682142,36.7407831 C30.4982914,36.8439309 30.4533205,36.9098595 30.3767257,37.0217403 L30.3266199,37.0948231 C30.3028683,37.148878 30.3028683,37.148878 30.375,36.9083933 Z"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-4",
    fill: "#FFFFFF",
    cx: 30,
    cy: 25,
    r: 3
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocal);
export default __webpack_public_path__ + "static/media/Local.e9934e46d7db5d732164c69cd3ad1198.svg";
export { ForwardRef as ReactComponent };